// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: #007bff;
  --blue-hover: #006ae6;
  --white: #fff;
  --black: #000;
  --text-light: #1a1818;
  --text-muted: rgba(0, 0, 0, 0.7);
  --hover-bg: rgba(0, 123, 255, 0.1);
  --shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

/* === Основная панель === */
.TopNav_TopNav__KrYLW {
  font-family: "Segoe UI", Calibri, Candara, Arial, sans-serif;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 45px;
  background: var(--white);
  box-shadow: var(--shadow);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.2rem;
  z-index: 1000;
  color: var(--black);
  overflow: hidden;
}

/* === Левая часть: хлебные крошки === */
.TopNav_breadcrumbs__fergb {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.95rem;
  flex-wrap: nowrap;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.TopNav_breadcrumbs__fergb::-webkit-scrollbar {
  display: none;
}

/* === Кнопка "Назад" === */
.TopNav_backButton__x2ZNE {
  background: none;
  border: none;
  color: var(--black);
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  padding: 0;
  flex-shrink: 0;
}

.TopNav_backButton__x2ZNE:hover {
  opacity: 0.8;
}

/* === Кнопочные хлебные крошки === */
.TopNav_navBtn__Biyf6 {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  background: transparent;
  border: 1px solid transparent;
  border-radius: 0.8rem;
  padding: 0.25rem 0.7rem;
  color: var(--black);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.15s ease;
  white-space: nowrap;
  cursor: pointer;
}

.TopNav_navBtn__Biyf6 i {
  font-size: 1rem;
  opacity: 0.9;
}

.TopNav_navBtn__Biyf6:hover {
  background: var(--hover-bg);
  border-color: var(--blue);
  color: var(--blue);
}

/* === Кнопка "Главная" === */
.TopNav_homeBtn__Fm\\+r8 {
  font-weight: 600;
}

/* === Текущая страница === */
.TopNav_currentPage__cp1g6 {
  background: var(--blue);
  color: var(--white);
  border-color: var(--blue);
  cursor: default;
}

.TopNav_currentPage__cp1g6:hover {
  background: var(--blue);
  color: var(--white);
}

/* === Разделитель (›) === */
.TopNav_separator__hSpiK {
  opacity: 0.5;
  font-size: 0.85rem;
  flex-shrink: 0;
  -webkit-user-select: none;
          user-select: none;
}

/* === Правая часть: пользователь === */
.TopNav_userSection__l\\+8lw {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.TopNav_userSection__l\\+8lw i {
  font-size: 1rem;
  opacity: 0.9;
}

.TopNav_logoutBtn__UHPn7 {
  background: none;
  border: none;
  color: var(--black);
  font-size: 1.1rem;
  cursor: pointer;
  transition: opacity 0.2s;
}

.TopNav_logoutBtn__UHPn7:hover {
  opacity: 0.8;
}

.TopNav_loginLink__JabkW {
  color: var(--black);
  text-decoration: none;
  font-weight: 500;
  transition: opacity 0.2s;
}

.TopNav_loginLink__JabkW:hover {
  opacity: 0.8;
}

/* === Мобильная адаптация === */
@media (max-width: 768px) {
  .TopNav_TopNav__KrYLW {
    padding: 0 0.8rem;
    height: 45px;
  }

  .TopNav_breadcrumbs__fergb {
    font-size: 0.9rem;
    flex: 1 1;
    overflow-x: auto;
    gap: 0.3rem;
  }

  .TopNav_navBtn__Biyf6 {
    font-size: 0.85rem;
    padding: 0.2rem 0.6rem;
  }

  .TopNav_navBtn__Biyf6 i {
    font-size: 0.9rem;
  }

  .TopNav_userSection__l\\+8lw {
    font-size: 0.85rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TopNav/TopNav.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,qBAAqB;EACrB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,gCAAgC;EAChC,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA,4BAA4B;AAC5B;EACE,4DAA4D;EAC5D,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,gCAAgC;AAChC;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,SAAO;IACP,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[":root {\r\n  --blue: #007bff;\r\n  --blue-hover: #006ae6;\r\n  --white: #fff;\r\n  --black: #000;\r\n  --text-light: #1a1818;\r\n  --text-muted: rgba(0, 0, 0, 0.7);\r\n  --hover-bg: rgba(0, 123, 255, 0.1);\r\n  --shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n/* === Основная панель === */\r\n.TopNav {\r\n  font-family: \"Segoe UI\", Calibri, Candara, Arial, sans-serif;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  height: 45px;\r\n  background: var(--white);\r\n  box-shadow: var(--shadow);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 0 1.2rem;\r\n  z-index: 1000;\r\n  color: var(--black);\r\n  overflow: hidden;\r\n}\r\n\r\n/* === Левая часть: хлебные крошки === */\r\n.breadcrumbs {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.4rem;\r\n  font-size: 0.95rem;\r\n  flex-wrap: nowrap;\r\n  min-width: 0;\r\n  overflow-x: auto;\r\n  scrollbar-width: none;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.breadcrumbs::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n/* === Кнопка \"Назад\" === */\r\n.backButton {\r\n  background: none;\r\n  border: none;\r\n  color: var(--black);\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: opacity 0.2s;\r\n  padding: 0;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.backButton:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n/* === Кнопочные хлебные крошки === */\r\n.navBtn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 0.35rem;\r\n  background: transparent;\r\n  border: 1px solid transparent;\r\n  border-radius: 0.8rem;\r\n  padding: 0.25rem 0.7rem;\r\n  color: var(--black);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: all 0.15s ease;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n\r\n.navBtn i {\r\n  font-size: 1rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.navBtn:hover {\r\n  background: var(--hover-bg);\r\n  border-color: var(--blue);\r\n  color: var(--blue);\r\n}\r\n\r\n/* === Кнопка \"Главная\" === */\r\n.homeBtn {\r\n  font-weight: 600;\r\n}\r\n\r\n/* === Текущая страница === */\r\n.currentPage {\r\n  background: var(--blue);\r\n  color: var(--white);\r\n  border-color: var(--blue);\r\n  cursor: default;\r\n}\r\n\r\n.currentPage:hover {\r\n  background: var(--blue);\r\n  color: var(--white);\r\n}\r\n\r\n/* === Разделитель (›) === */\r\n.separator {\r\n  opacity: 0.5;\r\n  font-size: 0.85rem;\r\n  flex-shrink: 0;\r\n  user-select: none;\r\n}\r\n\r\n/* === Правая часть: пользователь === */\r\n.userSection {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.6rem;\r\n  font-size: 0.95rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.userSection i {\r\n  font-size: 1rem;\r\n  opacity: 0.9;\r\n}\r\n\r\n.logoutBtn {\r\n  background: none;\r\n  border: none;\r\n  color: var(--black);\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.logoutBtn:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n.loginLink {\r\n  color: var(--black);\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n  transition: opacity 0.2s;\r\n}\r\n\r\n.loginLink:hover {\r\n  opacity: 0.8;\r\n}\r\n\r\n/* === Мобильная адаптация === */\r\n@media (max-width: 768px) {\r\n  .TopNav {\r\n    padding: 0 0.8rem;\r\n    height: 45px;\r\n  }\r\n\r\n  .breadcrumbs {\r\n    font-size: 0.9rem;\r\n    flex: 1;\r\n    overflow-x: auto;\r\n    gap: 0.3rem;\r\n  }\r\n\r\n  .navBtn {\r\n    font-size: 0.85rem;\r\n    padding: 0.2rem 0.6rem;\r\n  }\r\n\r\n  .navBtn i {\r\n    font-size: 0.9rem;\r\n  }\r\n\r\n  .userSection {\r\n    font-size: 0.85rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TopNav": `TopNav_TopNav__KrYLW`,
	"breadcrumbs": `TopNav_breadcrumbs__fergb`,
	"backButton": `TopNav_backButton__x2ZNE`,
	"navBtn": `TopNav_navBtn__Biyf6`,
	"homeBtn": `TopNav_homeBtn__Fm+r8`,
	"currentPage": `TopNav_currentPage__cp1g6`,
	"separator": `TopNav_separator__hSpiK`,
	"userSection": `TopNav_userSection__l+8lw`,
	"logoutBtn": `TopNav_logoutBtn__UHPn7`,
	"loginLink": `TopNav_loginLink__JabkW`
};
export default ___CSS_LOADER_EXPORT___;
